import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    primary: {
      50: '#1a3a66',   // light green for backgrounds, highlights
      100: '#c1eec9',
      200: '#9be3a8',
      300: '#75d887',
      400: '#50cc66',
      // 500: '#0e4a16',   // main primary color
      // 500: '#1c7db0',
      500: '#041c29',
      600: '#142c4d',
      700: '#1e6429',
      800: '#0f3e16',
      900: '#001801',
    },
    secondary: {
      50: '#e6f4ff',    // light blue for secondary highlights
      100: '#c2ddff',
      200: '#9cc5ff',
      300: '#76adff',
      400: '#5096ff',
      500: '#0e4a16',   // main secondary color
      600: '#2d61b3',
      700: '#204780',
      800: '#142c4d',
      900: '#07121b',
    },
  },
  components: {
    Heading: {
      baseStyle: {
        color: 'white',
      },
    },
  },
});

export default theme;
